import React from 'react';
import Footer from '../../components/Footers/Footer';
import IndexNavbar from 'components/Navbars/IndexNavbar';

const Confidentialite = () => {
  // Styles réutilisables
  const sectionStyle = {
    marginBottom: '2.5rem',
    background: 'rgba(15, 23, 42, 0.5)',
    borderRadius: '12px',
    overflow: 'hidden',
    border: '1px solid rgba(255, 255, 255, 0.05)'
  };

  const sectionHeaderStyle = {
    fontSize: '1.5rem',
    fontWeight: 700,
    color: '#ffffff',
    margin: 0,
    padding: '1.25rem 2rem',
    background: 'linear-gradient(90deg, rgba(14, 165, 233, 0.2) 0%, rgba(59, 130, 246, 0.2) 100%)',
    borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem'
  };

  const sectionContentStyle = {
    padding: '1.5rem 2rem'
  };

  const paragraphStyle = {
    color: '#e2e8f0', 
    margin: '0 0 1rem 0',
    lineHeight: '1.7'
  };

  const listStyle = {
    paddingLeft: '1.5rem',
    margin: '0 0 1rem 0'
  };

  const listItemStyle = {
    marginBottom: '0.5rem',
    lineHeight: '1.7',
    color: '#e2e8f0'
  };

  const highlightStyle = {
    color: '#0ea5e9',
    fontWeight: 600
  };

  const linkStyle = {
    color: '#0ea5e9',
    textDecoration: 'none',
    cursor: 'pointer'
  };

  const numberBadge = (number) => (
    <span style={{
      backgroundColor: '#0ea5e9',
      color: 'white',
      borderRadius: '9999px',
      width: '2rem',
      height: '2rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '0.875rem',
      fontWeight: 600,
      flexShrink: 0
    }}>
      {number}
    </span>
  );

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      background: 'linear-gradient(135deg, #0f172a 0%, #111827 35%, #0b1220 100%)',
      color: 'white',
      padding: '2rem 0',
      paddingTop: '6rem'
    }}>
      <main style={{
        width: '100%',
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 1rem'
      }}>
        <div style={{ 
          textAlign: 'center', 
          marginBottom: '3rem',
          padding: '2rem',
          background: 'rgba(255, 255, 255, 0.03)',
          borderRadius: '16px',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <h1 style={{
            fontSize: '2.5rem',
            fontWeight: 800,
            color: '#ffffff',
            marginBottom: '1rem',
            background: 'linear-gradient(90deg, #0ea5e9, #3b82f6)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            display: 'inline-block'
          }}>
            Politique de Confidentialité
          </h1>
          <p style={{
            fontSize: '1.125rem',
            color: '#94a3b8',
            maxWidth: '800px',
            margin: '0 auto'
          }}>
            Dernière mise à jour : 02 novembre 2025
          </p>
        </div>

        <div style={{
          backgroundColor: 'rgba(15, 23, 42, 0.7)',
          borderRadius: '16px',
          boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.3), 0 8px 10px -6px rgba(0, 0, 0, 0.2)',
          overflow: 'hidden',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <div style={{ 
            padding: '2.5rem',
            background: 'linear-gradient(180deg, rgba(30, 41, 59, 0.5) 0%, rgba(15, 23, 42, 0.7) 100%)'
          }}>

            {/* Article 1 : Introduction */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(1)}
                Introduction
              </h2>
              <div style={sectionContentStyle}>
                <p style={{...paragraphStyle, marginBottom: 0}}>
                  Chez AidFoundation, nous accordons une grande importance à la protection de vos données personnelles. Cette politique de confidentialité a pour but de vous informer sur la manière dont nous collectons, utilisons, partageons et protégeons vos données personnelles conformément au <span style={highlightStyle}>Règlement Général sur la Protection des Données (RGPD)</span> et à la <span style={highlightStyle}>loi Informatique et Libertés</span> modifiée.
                </p>
              </div>
            </section>

            {/* Article 2 : Données que nous collectons */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(2)}
                Données que nous collectons
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>
                  Nous pouvons collecter les catégories de données personnelles suivantes :
                </p>
                <ul style={{...listStyle, marginBottom: 0}}>
                  <li style={listItemStyle}><strong style={highlightStyle}>Données d'identification</strong> : nom, prénom, date de naissance, adresse email, numéro de téléphone, etc.</li>
                  <li style={listItemStyle}><strong style={highlightStyle}>Données de connexion</strong> : adresse IP, identifiants de connexion, historique de navigation, etc.</li>
                  <li style={listItemStyle}><strong style={highlightStyle}>Données financières</strong> : informations de paiement, historique des transactions, etc.</li>
                  <li style={listItemStyle}><strong style={highlightStyle}>Données de localisation</strong> : données de géolocalisation lorsque vous utilisez nos services mobiles.</li>
                  <li style={{...listItemStyle, marginBottom: 0}}><strong style={highlightStyle}>Données de navigation</strong> : pages consultées, durée de visite, clics, etc.</li>
                </ul>
              </div>
            </section>

            {/* Article 3 : Finalités du traitement */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(3)}
                Finalités du traitement
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>
                  Nous utilisons vos données personnelles aux fins suivantes :
                </p>
                <ul style={{...listStyle, marginBottom: 0}}>
                  <li style={listItemStyle}>Fournir et gérer nos services bancaires en ligne</li>
                  <li style={listItemStyle}>Vérifier votre identité et prévenir la fraude</li>
                  <li style={listItemStyle}>Vous contacter concernant votre compte ou nos services</li>
                  <li style={listItemStyle}>Améliorer nos services et personnaliser votre expérience</li>
                  <li style={listItemStyle}>Respecter nos obligations légales et réglementaires</li>
                  <li style={{...listItemStyle, marginBottom: 0}}>Vous envoyer des communications marketing (avec votre consentement)</li>
                </ul>
              </div>
            </section>

            {/* Article 4 : Bases légales du traitement */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(4)}
                Bases légales du traitement
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>
                  Le traitement de vos données est fondé sur :
                </p>
                <ul style={{...listStyle, marginBottom: 0}}>
                  <li style={listItemStyle}>L'exécution d'un contrat (fourniture de nos services bancaires)</li>
                  <li style={listItemStyle}>Le respect d'une obligation légale (conformité réglementaire)</li>
                  <li style={listItemStyle}>Votre consentement (pour le marketing direct, par exemple)</li>
                  <li style={{...listItemStyle, marginBottom: 0}}>Notre intérêt légitime (sécurité, amélioration de nos services, etc.)</li>
                </ul>
              </div>
            </section>

            {/* Article 5 : Destinataires des données */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(5)}
                Destinataires des données
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>
                  Vos données personnelles peuvent être partagées avec :
                </p>
                <ul style={listStyle}>
                  <li style={listItemStyle}>Nos prestataires de services (hébergeurs, prestataires de paiement, etc.)</li>
                  <li style={listItemStyle}>Les autorités réglementaires et judiciaires compétentes (si requis par la loi)</li>
                  <li style={listItemStyle}>Nos partenaires commerciaux (uniquement avec votre consentement explicite)</li>
                  <li style={{...listItemStyle, marginBottom: 0}}>En cas de fusion, acquisition ou cession d'actifs</li>
                </ul>
                <p style={{...paragraphStyle, marginBottom: 0}}>
                  Nous veillons à ce que tous nos prestataires respectent des normes strictes de sécurité et de confidentialité.
                </p>
              </div>
            </section>

            {/* Article 6 : Transferts de données hors UE */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(6)}
                Transferts de données hors UE
              </h2>
              <div style={sectionContentStyle}>
                <p style={{...paragraphStyle, marginBottom: 0}}>
                  Certains de nos prestataires peuvent être situés en dehors de l'Union Européenne. Dans ce cas, nous mettons en place des garanties appropriées, telles que les <span style={highlightStyle}>clauses contractuelles types de la Commission européenne</span>, pour assurer un niveau de protection adéquat de vos données.
                </p>
              </div>
            </section>

            {/* Article 7 : Durée de conservation */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(7)}
                Durée de conservation
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>
                  Nous conservons vos données personnelles aussi longtemps que nécessaire aux fins pour lesquelles elles ont été collectées, conformément à nos obligations légales et réglementaires. Par exemple :
                </p>
                <ul style={{...listStyle, marginBottom: 0}}>
                  <li style={listItemStyle}>Données de compte : durée de la relation contractuelle + 5 ans</li>
                  <li style={listItemStyle}>Données de transaction : 10 ans (obligation légale)</li>
                  <li style={listItemStyle}>Données de navigation : 13 mois</li>
                  <li style={{...listItemStyle, marginBottom: 0}}>Données de prospection commerciale : 3 ans à compter du dernier contact</li>
                </ul>
              </div>
            </section>

            {/* Article 8 : Sécurité des données */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(8)}
                Sécurité des données
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>
                  Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre tout accès non autorisé, modification, divulgation ou destruction. Ces mesures incluent :
                </p>
                <ul style={{...listStyle, marginBottom: 0}}>
                  <li style={listItemStyle}>Chiffrement des données sensibles</li>
                  <li style={listItemStyle}>Systèmes de détection et de prévention des intrusions</li>
                  <li style={listItemStyle}>Contrôles d'accès stricts</li>
                  <li style={listItemStyle}>Formation du personnel à la protection des données</li>
                  <li style={{...listItemStyle, marginBottom: 0}}>Audits de sécurité réguliers</li>
                </ul>
              </div>
            </section>

            {/* Article 9 : Vos droits */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(9)}
                Vos droits
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>
                  Conformément à la réglementation sur la protection des données, vous disposez des droits suivants :
                </p>
                <ul style={listStyle}>
                  <li style={listItemStyle}><strong style={highlightStyle}>Droit d'accès</strong> : obtenir la confirmation que des données vous concernant sont traitées et y accéder</li>
                  <li style={listItemStyle}><strong style={highlightStyle}>Droit de rectification</strong> : faire corriger des données inexactes</li>
                  <li style={listItemStyle}><strong style={highlightStyle}>Droit à l'effacement</strong> : demander la suppression de vos données dans certains cas</li>
                  <li style={listItemStyle}><strong style={highlightStyle}>Droit à la limitation</strong> : demander la limitation du traitement de vos données</li>
                  <li style={listItemStyle}><strong style={highlightStyle}>Droit à la portabilité</strong> : recevoir vos données dans un format structuré</li>
                  <li style={listItemStyle}><strong style={highlightStyle}>Droit d'opposition</strong> : vous opposer au traitement pour des raisons tenant à votre situation particulière</li>
                  <li style={{...listItemStyle, marginBottom: 0}}><strong style={highlightStyle}>Définir des directives</strong> relatives au sort de vos données après votre décès</li>
                </ul>
                <p style={paragraphStyle}>
                  Pour exercer ces droits ou pour toute question concernant la protection de vos données, vous pouvez nous contacter à l'adresse suivante :
                </p>
                <div style={{
                  padding: '1.5rem',
                  background: 'rgba(14, 165, 233, 0.1)',
                  borderRadius: '8px',
                  border: '1px solid rgba(14, 165, 233, 0.2)',
                  marginBottom: '1rem'
                }}>
                  <p style={{...paragraphStyle, margin: '0 0 0.5rem 0', fontWeight: 600}}>Délégué à la Protection des Données (DPO)</p>
                  <p style={{...paragraphStyle, margin: '0 0 0.5rem 0'}}>AidFoundation</p>
                  <p style={{...paragraphStyle, margin: '0 0 0.5rem 0'}}>
                    Email : <a href="mailto:contact@aidfoundation.eu" style={linkStyle}>contact@aidfoundation.eu</a>
                  </p>
                  <p style={{...paragraphStyle, margin: 0}}>Adresse : 123 Rue de la Finance, 75001 Paris, France</p>
                </div>
                <p style={{...paragraphStyle, marginBottom: 0}}>
                  Vous avez également le droit d'introduire une réclamation auprès de la <span style={highlightStyle}>CNIL (Commission Nationale de l'Informatique et des Libertés)</span> si vous estimez que le traitement de vos données personnelles n'est pas conforme à la réglementation.
                </p>
              </div>
            </section>

            {/* Article 10 : Mises à jour de cette politique */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(10)}
                Mises à jour de cette politique
              </h2>
              <div style={sectionContentStyle}>
                <p style={{...paragraphStyle, marginBottom: 0}}>
                  Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. Toute mise à jour sera publiée sur cette page avec une date de révision mise à jour. Nous vous encourageons à consulter régulièrement cette politique pour rester informé de la façon dont nous protégeons vos informations.
                </p>
              </div>
            </section>

            {/* Article 11 : Nous contacter */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(11)}
                Nous contacter
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>
                  Pour toute question concernant cette politique de confidentialité ou nos pratiques en matière de protection des données, veuillez nous contacter :
                </p>
                <div style={{
                  padding: '1.5rem',
                  background: 'rgba(14, 165, 233, 0.1)',
                  borderRadius: '8px',
                  border: '1px solid rgba(14, 165, 233, 0.2)'
                }}>
                  <p style={{...paragraphStyle, margin: '0 0 0.5rem 0', fontWeight: 600}}>AidFoundation</p>
                  <p style={{...paragraphStyle, margin: '0 0 0.5rem 0'}}>Service Protection des Données</p>
                  <p style={{...paragraphStyle, margin: '0 0 0.5rem 0'}}>123 Rue de la Finance</p>
                  <p style={{...paragraphStyle, margin: '0 0 0.5rem 0'}}>75001 Paris, France</p>
                  <p style={{...paragraphStyle, margin: '0 0 0.5rem 0'}}>
                    Email : <a href="mailto:donnees-personnelles@unpaidfinancial.com" style={linkStyle}>donnees-personnelles@unpaidfinancial.com</a>
                  </p>
                  <p style={{...paragraphStyle, margin: 0}}>
                    Téléphone : <a href="tel:+33774137802" style={linkStyle}>+33 7 74 13 78 02</a>
                  </p>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Confidentialite;